import {
  Component,
  forwardRef,
  Injector,
  Input,
  OnInit
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl
} from '@angular/forms';

export interface ISwitchProps {
  type: 'BIG' | 'REGULAR'
}

/**
 * A general propose switch component with implementation to accept ng-model and formcontrol
 */
@Component(
  {
    selector: 'app-switch',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SwitchComponent),
            multi: true
        }
    ],
    standalone: false
}
)
export class SwitchComponent implements OnInit, ControlValueAccessor {

  @Input()
  props: ISwitchProps

  value = false;
  disabled= false;

  _control: NgControl;

  constructor(private readonly injector: Injector) { }


  onTouched = () => {
  };

  onChange = (value: boolean) => {
  };

  ngOnInit(): void {
    this._control = this.injector.get(NgControl, null);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    this.value = obj;
    this.onChange(obj)
  }

}
